export default __webpack_public_path__ + "static/media/sayve.21f72a17.png";